import styled from "styled-components";

export const WelcomeContainer = styled.div`
  background: rgb(63, 15, 64);
  background: linear-gradient(
  180deg,
  rgba(63, 15, 64, 1) 0%,
  rgba(108, 9, 110, 1) 96%);
  width: 100%;
  height: calc(100vh - 60px);
  margin: 60px 0 0 0;

  @media (min-width:1000px) {
    margin: 60px 0 0 250px;
  }

`;

export const ImgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;

  > img {
    position: absolute;
    top: 400px;
    width: 200px;

    @media (min-width:1000px) {
      width: 400px;
    }
  }
`;

export const OptionsContainer = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  @media (min-width:1000px) {
    margin: 100px;
  }

  > h1 {
    margin: 30px;
    text-transform: uppercase;
  }

  > h3 {
    text-transform: uppercase;
    padding: 0 20px;
  }

  > ul {
    display: flex;
    margin: 40px 0;
    padding: 0;
    list-style-type: none;

    > li {
      margin: 0 10px;

      @media (min-width:1000px) {
        margin: 20px 25px;
      }

      > Button {
        color: white;
        border: 1px solid lightgray;

        :hover {
          background-color: lightgray;

          > span > a {
            color: black;
          }
        }

        > span > a {
          text-decoration: none;
          color: white;
        }
      }
    }

    @media (min-width: 1000px) {
      padding: 0 0 0 40px;
    }
  }
`;
